import validate from "/mcc/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.0_@types+node@20.17.19_db0@0.3.2_eslint@8.57.1_ioredis@_9e52384084a119f0ed2f606dbdb42f59/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/mcc/src/middleware/redirect.global.ts";
import manifest_45route_45rule from "/mcc/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.0_@types+node@20.17.19_db0@0.3.2_eslint@8.57.1_ioredis@_9e52384084a119f0ed2f606dbdb42f59/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/mcc/src/middleware/admin.ts"),
  auth: () => import("/mcc/src/middleware/auth.ts"),
  committee: () => import("/mcc/src/middleware/committee.ts"),
  "public-only": () => import("/mcc/src/middleware/public-only.ts")
}